export default {
  name: 'LayoutLogin',
  render (h) {
    return h('el-container', {
      attrs: {
        style: 'height: 100%;'
      }
    }, [
      h('el-header', this.$slots.header),
      h('el-container', {
        attrs: {
          style: 'padding: 0 20px;'
        }
      }, [
        h('el-main', this.$slots.main),
        h('el-aside', {
          props: {
            width: '500px'
          }
        }, this.$slots.aside)
      ])
    ])
  }
}
